/* eslint-disable max-len */
export default {
  ACTIONS: {
    FINISH: 'Finish',
    NEXT: 'Next'
  },
  ERRORS: {
    GREATER_THAN: 'Can\'t be higher than {max}.',
    INVALID_PROZIS_POINTS:
      'Oops, the ProzisPoints you wanted to share with the courier are no longer available. Please try again.',
    LESS_THAN: 'Can\'t be lower than {min}.',
    MAX_CHARACTERS: 'Description must have a maximum of {max} characters.',
    REQUIRED: 'Required field.',
    VALIDATING_CODE: 'Unable to validate the code {code}.'
  },
  LABELS: {
    COMMENT: 'Comment',
    COURIER: 'courier',
    ERROR: 'Error',
    EXPERIENCE_EVALUATION: 'RATE YOUR DELIVERY EXPERIENCE',
    MORE_TO_SAY: 'IMPROVE OURSELVES',
    OTHER: 'Other',
    PROZIS_NOW: 'PROZIS NOW'
  },
  SENTENCES: {
    AMAZED:
      '😁 We\'re very happy to hear everything went well. What did you like best?',
    ANSWERED_SURVEY:
      'We already have your feedback on the delivery of order {code}. \n\rLooking forward to hearing about your future experiences, though. 👍',
    ENTITY: 'What did you think of {entity}?',
    POINTS: 'You have {points} ProzisPoints.',
    SATISFIED: '😁 We\'re glad it went well, but how can we improve?',
    SHARE_POINTS:
      'Would you like to reward {entity}? Share your ProzisPoints with him. 🙂',
    THANKS: '😀 Thank you, {name}.',
    UNHAPPY:
      '😔 We\'re sad to hear the delivery did not go as expected. What went wrong?'
  }
};
